import { ProfileCustomValuesList } from "PFApp/components/custom_values_list";
import { SkillsExplorer } from "PFApp/profiles/show/parts/charts/skills_explorer";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { FeatureFlag, Profile } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "../../../../parts/overview/detail_view/detail_view.module.scss";
import { Label } from "../parts/label";

const SKILLS_LIMIT = 5;

interface SkillsProps {
  profile: Profile;
}

export const Skills = ({ profile }: SkillsProps) => {
  const { t } = useTranslation("translation");
  const isChartFeatureEnabled = useIsFeatureEnabled(FeatureFlag.ShowSkillCategories);
  const skillsExplorerAvailable =
    isChartFeatureEnabled && profile.skillCategories && profile.skillCategories.length > 0;
  const skills = profile.skills || [];

  return (
    <div className={css.item} style={{ height: 500 }}>
      <Label text={t("skills")} />
      {skillsExplorerAvailable ? (
        <SkillsExplorer profile={profile} skills={skills} maxSkillNameLength={22} />
      ) : (
        <ProfileCustomValuesList
          customFieldName="skills"
          customValues={skills}
          profileId={profile.id}
          limit={SKILLS_LIMIT}
        />
      )}
    </div>
  );
};
